import { CopyableText, copyIconButtonClasses } from './copyable-text';
import { TooltippedText } from './tooltipped-text';

/**
 * An email address as plain text with copy and send-mail icons. Replaces the bare
 * `mailto:` hyperlink pattern (see .mex/SWEEPS.md) — a click on the address itself
 * no longer launches a mail app.
 */
export function EmailContact({
  email,
  className,
  'data-testid': testId,
}: {
  email: string;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <CopyableText
      value={email}
      copiedMessage="Email copied"
      className={className}
      data-testid={testId}
    >
      <TooltippedText tooltipContent="Send email">
        <a
          href={encodeURI(`mailto:${email}`)}
          className={copyIconButtonClasses}
          aria-label={`Email ${email}`}
          data-testid="email-send"
        >
          <i className="far fa-fw fa-envelope tw:text-[11px]" />
        </a>
      </TooltippedText>
    </CopyableText>
  );
}
